/**
 * Normalizes free typing into a money-like string: digits and at most one decimal point, up to 2 fractional digits.
 * Leading ".5" becomes "0.5".
 */
export function sanitizeMoneyInput(raw: string): string {
    const cleaned = raw.replace(/[^0-9.]/g, '');
    const firstDot = cleaned.indexOf('.');
    if (firstDot === -1) {
        return cleaned;
    }
    let intPart = cleaned.slice(0, firstDot);
    const decPart = cleaned.slice(firstDot + 1).replace(/\./g, '');
    if (firstDot === 0 && decPart.length > 0) {
        intPart = '0';
    }
    return intPart + '.' + decPart.slice(0, 2);
}
